import { Portfolio, ProductLineAttr } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { PRODUCT_LINES_CONTENT_MAP } from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';
import { Catalog } from 'types/productService';

export const getProductLineAttributesFromCatalog = (
  catalog: Catalog,
  productLineId: ProductLineId,
): ProductLineAttr[] => {
  const label = PRODUCT_LINES_CONTENT_MAP[productLineId].joinedLabel;
  return catalog.productLineAttributes.filter((attribute) => {
    return attribute.productLine.replaceAll(' ', '') === label;
  });
};

export const combinePortfolios = (portfolios: Portfolio[], portfoliosWithBc: Portfolio[]): Portfolio[] => {
  const allPortfolios = [...portfoliosWithBc];

  portfolios.forEach((portfolio) => {
    const currentPortfolio = portfoliosWithBc.find((bcPortfolio) => bcPortfolio.id === portfolio.id);
    if (!currentPortfolio) {
      allPortfolios.push(portfolio);
    }
  });

  return allPortfolios;
};
